import { useFormContext, useWatch } from "react-hook-form";
import { SaleOrdersFormTyping } from "../../types";
import { useGetModuleCustomerQuery } from "@redux/features/customers/customersApi";
import LanguageDropdownSection from "@ready/language";
import { useShouldSkipCopyAutofill } from "../../CopyHydrationContext";

const LANGUAGE_STORAGE_KEY = "sale-order.language";

export default function LanguageSection() {
    const { control } = useFormContext<SaleOrdersFormTyping>();

    const customer = useWatch({
        control,
        name: "customer",
    });
    const shouldSkipCopyAutofill = useShouldSkipCopyAutofill(customer?.id);

    const mode = useWatch({
        control,
        name: "mode",
    });

    const { data: extendedCustomerData, isFetching: isExtendedCustomerDataFetching } =
        useGetModuleCustomerQuery(
            { module: "sale", id: customer?.id as number },
            { skip: !customer || mode === "editing" }
        );

    const activeCustomerData =
        extendedCustomerData?.id === customer?.id ? extendedCustomerData : undefined;

    return (
        <LanguageDropdownSection
            storageKey={LANGUAGE_STORAGE_KEY}
            entityId={customer?.id}
            entityLanguage={activeCustomerData?.language}
            isEntityDefaultPending={
                mode === "creation" &&
                !!customer?.id &&
                !activeCustomerData &&
                isExtendedCustomerDataFetching
            }
            skipInitialEntityHydration={shouldSkipCopyAutofill}
            translationKeyPrefix="sales.orders.language"
        />
    );
}
